import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import { MatDialog } from "@angular/material/dialog";
import { EditInvoiceComponent } from "../edit-invoice/edit-invoice.component";
import { AddInvoiceComponent } from "../add-invoice/add-invoice.component";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ImagePreviewComponent } from "../image-preview/image-preview.component";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-edit-lr",
  templateUrl: "./edit-lr.component.html",
  styleUrls: ["./edit-lr.component.css"],
}) 
export class EditLrComponent implements OnInit {
  today = new Date().toISOString().split("T")[0];
yesterday = new Date(Date.now() - 86400000).toISOString().split("T")[0];

  isDisabled: boolean = true;
  labourLoad;
  labourUnload;
  Tollfiles: Array<File> = [];
  TollfilesString = [];
  userroleid;
  userSessionData;
  isRoleSuperVisor = false;
  isFileNameShown = true;
  isFileSelcted = false;
  notShown = false;
  isShown = true;
  vehicles: any;
  vehiclesNumber = [];
  vehicleTypesNames = [];
  DriverNames = [];
  DriverNumbers = [];
  filteredVehicleTypes: Observable<string[]>;
  filteredVehicleNo: Observable<string[]>;
  filteredDriverName: Observable<string[]>;
  filteredDriverNumber: Observable<string[]>;
  podBack: Array<File> = [];
  loadingSlipsBack: Array<File> = [];
  loadingSlipsBackString = [];
  InvoiceDetails = [];
  clientList = [];
  particlarLR: any;
  fileNameLoad: any;
  fileNameLoadBack: any;
  vehiclesDetail: any;
  submitLRClicked = false;
  actualbalance: any = 0;
  updownkm: any = 0;
  paramId;
  previewLoadingSlipURL: any;
  apiUrl = environment.domain;
  @ViewChild("showLoadingSlipPreview") showLoadingSlipPreview: ElementRef;
  editLR = new FormGroup({
    supervisorname: new FormControl(""),
    clientList: new FormControl(""),
    ConsigneeName: new FormControl(""),
    ConsigneeAddress: new FormControl(""),
    ConsignorName: new FormControl(""),
    ConsignorAddress: new FormControl(""),
    VehicleNo: new FormControl(""),
    vehicleType: new FormControl(""),
    from: new FormControl(""),
    to: new FormControl(""),
    GSTIN: new FormControl(""),
    date: new FormControl(""),
    RoadPermitNo: new FormControl(""),
    DLY: new FormControl(""),
    DeclaredValue: new FormControl(""),
    fixAdhoc: new FormControl(""),
    quantity: new FormControl(""),
    transportorName: new FormControl(""),
    transportorMobile: new FormControl(
      "",
      Validators.compose([Validators.pattern(/^\d{10}$/)])
    ),
    driverName: new FormControl(""),
    driverMobile: new FormControl(""),
    tollAttachment: new FormControl(""),
    loadingSlipAttchment: new FormControl(""),
    loadingSlipAttchmentBack: new FormControl(""),
    Frieght: new FormControl(""),
    tripSDate: new FormControl(""),
    tripEDate: new FormControl(""),
    outtime: new FormControl(""),
    INtime: new FormControl(""),
    noofTools: new FormControl(""),
    tooltaxPaid: new FormControl(""),
    labourPaid: new FormControl(""),
    otherPayment: new FormControl(""),
    updownkm: new FormControl(""),
    totalhour: new FormControl(""),
    extrahour: new FormControl(""),
    detention: new FormControl(""),
    advance: new FormControl(""),
    balance: new FormControl(""),
    balancePaid: new FormControl(""),
    labourLoad: new FormControl(""),
    labourUnload: new FormControl(""),
    vehicleRate: new FormControl(""),
    LR_no: new FormControl(""),
    manualLR_no: new FormControl(""),
    dieselExpense: new FormControl(""),
    driverCash: new FormControl(""),
    truckExpense: new FormControl(""),
    TDS: new FormControl("", Validators.pattern("^[0-9]*$")),
    munsipalAmount: new FormControl("", Validators.pattern("^[0-9]*$")),
    finalAmount: new FormControl("", Validators.pattern("^[0-9]*$")),
    otherPaymentDescription: new FormControl(""),
  });
  docURL: any;
  superVisor: any;
  @ViewChild("showDoc") showDoc: ElementRef;
  get ff() {
    "No Attachment Found";
    return this.editLR.controls;
  }
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.paramId = param.id;
      this.getLRDetail(this.paramId);
    });
  }

  existingTollFiles: string[] = [];
  previewTollFiles: (File | string)[] = [];

  ngOnInit(): void {
    this.getClientList();
    this.getVehicleType();
    this.getDriverNames();
    this.getVehicleDetails();
    this.userSessionData = JSON.parse(sessionStorage.getItem("userSession"));
    this.userroleid = this.userSessionData.user_role_id[0];
    if (this.userroleid === 2) {
      this.isRoleSuperVisor = true;
      this.editLR.controls.supervisorname.disable();
    }
    this.getSuperVisorName();
    // if (this.particlarLR?.loadingSlipAttchment?.length) {
    //   this.existingTollFiles = this.particlarLR.loadingSlipAttchment.map(
    //     (url) => {
    //       if (url.startsWith("http://") || url.startsWith("https://"))
    //         return url;
    //       return this.apiUrl + "/" + url;
    //     }
    //   );
    //   this.previewTollFiles = [...this.existingTollFiles];

    //   this.previewTollFiles = [...this.existingTollFiles];
    // }
  }

  getVehicleType() {
    this.superAdminService.getVehicleType().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          rawdata.forEach((item) => {
            this.vehicleTypesNames.push(item.vehicletype_name);
          });
          this.filteredVehicleTypes = this.ff.vehicleType.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterVehicleType(value || ""))
          );
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  private _filterVehicleType(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.vehicleTypesNames.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  getVehicleDetails() {
    this.superAdminService.getvehicles().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          this.vehicles = res.data;
          this.vehicles.forEach((item) => {
            this.vehiclesNumber.push(item.vehicle_no);
          });
          this.filteredVehicleNo = this.ff.VehicleNo.valueChanges.pipe(
            startWith(this.editLR.get("VehicleNo")?.value || ""),
            map((value) => this._filterVehicleNo(value))
          );
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  private _filterVehicleNo(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.vehiclesNumber.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  getDriverNames() {
    this.superAdminService.getDrivers().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          rawdata.forEach((item) => {
            if (item.driver_name) {
              this.DriverNames.push(item.driver_name);
            }
            if (item.contactNumber) {
              this.DriverNumbers.push(item.contactNumber);
            }
          });
          this.filteredDriverName = this.ff.driverName.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterDriverName(value || ""))
          );
          this.filteredDriverNumber = this.ff.driverMobile.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterDriverNumber(value || ""))
          );
          //this.dtOptions.data = this.users;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  private _filterDriverName(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.DriverNames.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  private _filterDriverNumber(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.DriverNumbers.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  getClientList() {
    this.superAdminService.getClientList().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.clientList = rawdata;
          //console.log(this.company);
          //this.dtOptions.data = this.users;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            if (res.status == 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.success(res.message);
            }
          }
        }
      },
      (error) => {}
    );
  }

  getLRDetail(id: string) {
    this.superAdminService.particlarLR(id).subscribe({
      next: (res: any) => {
        if (!res?.status || !Array.isArray(res.data) || !res.data.length) {
          this.toastr.error("LR data not found");
          return;
        }

        this.particlarLR = res.data[0];
        this.editLR.patchValue(this.mapLRToForm(this.particlarLR));

        setTimeout(() => {
          this.editLR
            .get("VehicleNo")
            ?.setValue(this.particlarLR.vehicle_id || "");
          this.editLR
            .get("vehicleType")
            ?.setValue(this.particlarLR.vehicleType || "");
          this.editLR
            .get("driverName")
            ?.setValue(this.particlarLR.driverName || "");
          this.editLR
            .get("driverMobile")
            ?.setValue(this.particlarLR.driverMobile || "");
        });

        this.existingTollFiles = (
          this.particlarLR.loadingSlipAttchment || []
        ).map((f) => this.normalizeUrl(f));
        this.previewTollFiles = [...this.existingTollFiles];

        this.lastTollFileName = this.existingTollFiles.length
          ? this.existingTollFiles[this.existingTollFiles.length - 1]
              .split("/")
              .pop()
          : "";
      },
      error: () => {
        this.toastr.error("Failed to load LR details");
      },
    });
  }

  mapLRToForm(lr: any) {
    return {
      supervisorname: lr.supervisorId,
      clientList: lr.clientId,
      manualLR_no: lr.manualLR_no,
      ConsigneeName: lr.consignee_name,
      ConsigneeAddress: lr.consignee_address,
      ConsignorName: lr.consignor_name,
      ConsignorAddress: lr.consignor_address,

      VehicleNo: lr.vehicle_id,
      vehicleType: lr.vehicleType,

      from: lr.from,
      to: lr.to,
      GSTIN: lr.GSTIN,

      date: lr.date ? this.formatDate(lr.date) : "",

      RoadPermitNo: lr.road_permit_no ?? "",
      DLY: lr.dly_no ?? "",
      DeclaredValue: lr.declared_value ?? "",

      quantity: lr.quantity,
      transportorName: lr.transportorName,
      transportorMobile: lr.transportorMobile,
      driverName: lr.driverName,
      driverMobile: lr.driverMobile,

      Frieght: lr.Frieght,

      tripSDate: lr.tripStartDate ? this.formatDate(lr.tripStartDate) : "",
      tripEDate: lr.tripEndDate ? this.formatDate(lr.tripEndDate) : "",

      vehicleRate: lr.vehicleRate,
      advance: lr.advance,
      balance: lr.balance,
      balancePaid: lr.balancePaid,

      otherPayment: lr.otherPayment,
      otherPaymentDescription: lr.otherPaymentDescription,

      labourLoad: lr.labourLoad,
      labourUnload: lr.labourUnload,

      TDS: lr.TDS,
      munsipalAmount: lr.munsipalAmount,
      finalAmount: lr.finalAmount,
    };
  }

  formatDate(date: string) {
    return new Date(date).toISOString().substring(0, 10);
  }

  // Existing attachments from backend
  existingLoadingSlips: string[] = [];
  existingLoadingSlipsBack: string[] = [];

  // Newly selected files
  newLoadingSlips: File[] = [];
  newLoadingSlipsBack: File[] = [];

  // Preview array combining both
  previewLoadingSlips: (File | string)[] = [];
  previewLoadingSlipsBack: (File | string)[] = [];

  initform() {
    this.editLR.patchValue(this.mapLRToForm(this.particlarLR));

    setTimeout(() => {
      this.editLR.get("VehicleNo")?.setValue(this.particlarLR.vehicle_id);
      this.editLR.get("vehicleType")?.setValue(this.particlarLR.vehicleType);
      this.editLR.get("driverName")?.setValue(this.particlarLR.driverName);
      this.editLR.get("driverMobile")?.setValue(this.particlarLR.driverMobile);
    });
  }

  onFocusOutEvent(event: any) {
    this.actualbalance =
      parseInt(this.editLR.get("vehicleRate").value) -
      parseInt(this.editLR.get("advance").value) -
      parseInt(event.target.value);
    this.editLR.patchValue({
      balance: this.actualbalance,
    });
  }
  normalizeUrl(url: string) {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    return `${this.apiUrl}${url.startsWith("/") ? "" : "/"}${url}`;
  }
  newTollFiles: File[] = [];

  onFocusOutendmeterReading(event: any) {
    this.updownkm =
      parseInt(event.target.value) -
      parseInt(this.editLR.get("startmeterReading").value);
    this.editLR.patchValue({
      updownkm: this.updownkm,
    });
  }

  // Update preview list
  fileChangeEventtollAttachment(event: any) {
    const files: FileList = event.target.files;

    for (let i = 0; i < files.length; i++) {
      this.newTollFiles.push(files[i]);
    }

    this.updatePreviewFiles();

    // Update last uploaded file name safely
    const allFiles = [...this.existingTollFiles, ...this.newTollFiles];
    const lastFile = allFiles[allFiles.length - 1];

    if (lastFile instanceof File) {
      this.lastTollFileName = lastFile.name;
    } else if (typeof lastFile === "string") {
      this.lastTollFileName = lastFile.split("/").pop() || lastFile;
    } else {
      this.lastTollFileName = "";
    }

    event.target.value = "";
  }

  // Merge existing + new files for preview
  updatePreviewFiles() {
    this.previewTollFiles = [...this.existingTollFiles, ...this.newTollFiles];
  }

  lastFileName: string = "";
  viewImage(imgBase64: string) {
    const newTab = window.open();

    if (newTab) {
      newTab.document.body.innerHTML = `
      <html>
        <head>
          <title>View Image</title>
        </head>
        <body>
          <img src="${imgBase64}" style="max-width: 100%;" onerror="alert('Failed to load image.');">
        </body>
      </html>
    `;
    } else {
      console.error("Failed to open new tab");
    }
  }

  // Upload new files
  addTollFiles() {
    if (!this.newTollFiles.length) return;

    const formData = new FormData();
    this.newTollFiles.forEach((file) => formData.append("Tollfiles[]", file));

    this.superAdminService.addTollFiles(formData).subscribe((res: any) => {
      if (res.status) {
        this.toastr.success(res.message);

        const uploadedPaths = res.rawdata.map((f) => f.url);
        this.existingTollFiles.push(...uploadedPaths);
        this.previewTollFiles = [...this.existingTollFiles];
        // Clear newTollFiles
        this.newTollFiles = [];
      } else {
        this.toastr.error(res.message);
      }
    });
  }

  newTollFilesString: string[] = [];
  updateLRSubmit() {
    this.submitLRClicked = true;

    if (this.editLR.get("manualLR_no")?.hasError("duplicate")) {
      this.toastr.error("Please fix Manual LR number before submitting");
      this.addvalidatorcss("manualLR_noctrl");
      return;
    }
    if (!this.editLR.valid) {
      const controls = [
        "supervisorname",
        "ConsigneeName",
        "ConsigneeAddress",
        "ConsignorName",
        "ConsignorAddress",
        "VehicleNo",
        "from",
        "to",
        "GSTIN",
        "date",
        "labourLoad",
        "labourUnload",
        "loadingSlipAttchmentBack",
        "otherPayment",
        "updownkm",
        "totalhour",
        "vehicleRate",
        "transportorMobile",
        "outtime",
        "INtime",
      ];
      controls.forEach((ctrl) => {
        if (this.editLR.get(ctrl).invalid) this.addvalidatorcss(ctrl + "ctrl");
        else this.removevalidatorcss(ctrl + "ctrl");
      });
      return;
    }

    this.spinner.show();

    const submitUpdate = () => {
      const updatedTollAttachments = [
        ...(this.existingTollFiles || []),
        ...(this.TollfilesString || []),
      ];

      const updatedLoadingSlipBack = [
        ...(this.particlarLR.loadingSlipAttchmentBack || []).map((p) =>
          p.startsWith("http") ? p : `${environment.domain}${p}`
        ),
        ...(this.loadingSlipsBackString || []),
      ];

      const form = {
        _id: this.particlarLR._id,
        clientList: this.editLR.get("clientList").value,
        supervisorId: this.editLR.get("supervisorname").value,
        manualLR_no: this.editLR.get("manualLR_no").value,
        ConsigneeName: this.editLR.get("ConsigneeName").value,
        ConsigneeAddress: this.editLR.get("ConsigneeAddress").value,
        ConsignorName: this.editLR.get("ConsignorName").value,
        ConsignorAddress: this.editLR.get("ConsignorAddress").value,
        VehicleNo: this.editLR.get("VehicleNo").value,
        vehicleType: this.editLR.get("vehicleType").value,
        GSTIN: this.editLR.get("GSTIN").value,
        from: this.editLR.get("from").value,
        to: this.editLR.get("to").value,
        RoadPermitNo: this.editLR.get("RoadPermitNo").value,
        DLY: this.editLR.get("DLY").value,
        DeclaredValue: this.editLR.get("DeclaredValue").value,
        quantity: this.editLR.get("quantity").value,
        transportorName: this.editLR.get("transportorName").value,
        transportorMobile: this.editLR.get("transportorMobile").value,
        driverName: this.editLR.get("driverName").value,
        driverMobile: this.editLR.get("driverMobile").value,
        Frieght: this.editLR.get("Frieght").value,
        date: this.editLR.get("date").value,
        tripSDate: this.editLR.get("tripSDate").value,
        tripEDate: this.editLR.get("tripEDate").value,
        loadingSlipAttchment: updatedTollAttachments,
        loadingSlipAttchmentBack: updatedLoadingSlipBack,
        labourLoad: this.editLR.get("labourLoad").value,
        labourUnload: this.editLR.get("labourUnload").value,
        otherPayment: this.editLR.get("otherPayment").value,
        updownkm: this.editLR.get("updownkm").value,
        totalhour: this.editLR.get("totalhour").value,
        extrahour: this.editLR.get("extrahour").value,
        detention: this.editLR.get("detention").value,
        advance: this.editLR.get("advance").value,
        balance: this.editLR.get("balance").value,
        balancePaid: this.editLR.get("balancePaid").value,
        vehicleRate: this.editLR.get("vehicleRate").value,
        dieselExpense: this.editLR.get("dieselExpense").value,
        otherPaymentDescription: this.editLR.get("otherPaymentDescription")
          .value,

        TDS: this.editLR.get("TDS").value,
        munsipalAmount: this.editLR.get("munsipalAmount").value,
        finalAmount: this.editLR.get("finalAmount").value,
      };

      // Prepare FormData for new files if any
      const formData = new FormData();
      if (this.newTollFiles?.length) {
        this.newTollFiles.forEach((f) => formData.append("Tollfiles[]", f));
      }
      formData.append("myFormData", JSON.stringify(form));

      // API call
      this.superAdminService.updateLR({ form }).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.toastr.success(res.message);
            this.router.navigate(["/superAdmin/lrmanagement"]);
          } else {
            this.toastr.error(res.message);
          }
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        },
      });
    };

    // If new files exist, upload first then submit update
    if (this.newTollFiles.length) {
      const formData = new FormData();
      this.newTollFiles.forEach((f) => formData.append("Tollfiles[]", f));

      this.superAdminService.addTollFiles(formData).subscribe({
        next: (res: any) => {
          if (res.status) {
            const uploadedPaths = res.rawdata
              .map((f) =>
                typeof f === "string"
                  ? this.normalizeUrl(f)
                  : this.normalizeUrl(f.url || "")
              )
              .filter(Boolean);

            this.existingTollFiles.push(...uploadedPaths);
            this.previewTollFiles = [...this.existingTollFiles];
            this.newTollFiles = [];
            submitUpdate();
          } else {
            this.toastr.error(res.message);
            this.spinner.hide();
          }
        },
        error: () => {
          this.toastr.error("Failed to upload attachments");
          this.spinner.hide();
        },
      });
    } else {
      submitUpdate();
    }
  }

  addvalidatorcss(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.add("validatorcss");
    }
  }

  removevalidatorcss(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.remove("validatorcss");
    }
  }

  getSuperVisorName() {
    this.superAdminService.getSuperVisorName().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.superVisor = rawdata;
          //this.dtOptions.data = this.users;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  addnewinv(acc) {
    const dialogRef = this.dialog.open(AddInvoiceComponent, {
      panelClass: "addInvoice",
      data: {
        acc,
        getLrDetail: () => {
          this.getLRDetail(this.paramId);
        },
      },
    });
  }
  editInvoice(acc, id): void {
    const dialogRef = this.dialog.open(EditInvoiceComponent, {
      panelClass: "addInvoice",
      data: {
        acc,
        id,
        trackerId: this.particlarLR?._id,
        getLrDetail: () => {
          this.getLRDetail(this.paramId);
        },
      },
    });
  }

  previewLoadingSlip(file: File | string) {
    if (!file) return this.toastr.error("No attachment");

    if (file instanceof File) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          file.type
        )
      ) {
        this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file },
        });
      } else {
        const url = URL.createObjectURL(file);
        window.open(url, "_blank");
      }
    } else {
      // string URL
      const fileExtension = file.split(".").pop()?.toLowerCase() || "";
      if (["jpeg", "png", "jpg", "svg"].includes(fileExtension)) {
        this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file },
        });
      } else {
        window.open(file, "_blank");
      }
    }
  }
  // Preview button click
  previewFile(file: File | string) {
    if (file instanceof File) {
      const url = URL.createObjectURL(file);
      window.open(url, "_blank");
    } else {
      // DO NOT prepend API URL again
      window.open(file, "_blank");
    }
  }

  // Choose file
  chooseFile() {
    document.getElementById("loadingSlipAttachmentCtrl")?.click();
  }

  getFileName(pathOrFile: string | File): string {
    if (typeof pathOrFile === "string")
      return pathOrFile.split("/").pop() || pathOrFile;
    else return pathOrFile.name;
  }
  isImage(file: File | string): boolean {
    if (file instanceof File) {
      return file.type.startsWith("image/");
    } else if (typeof file === "string") {
      const ext = file.split(".").pop()?.toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "svg"].includes(ext!);
    }
    return false;
  }
  isPDF(file: File | string): boolean {
    if (file instanceof File) {
      return file.type === "application/pdf";
    } else if (typeof file === "string") {
      return file.toLowerCase().endsWith(".pdf");
    }
    return false;
  }
  viewPDF(file: File | string) {
    const fileUrl =
      file instanceof File
        ? URL.createObjectURL(file)
        : file.startsWith("http")
        ? file
        : `${this.apiUrl}/${file}`;
    window.open(fileUrl, "_blank");
  }

  // Get the source for preview
  getFileSrc(file: File | string): string {
    if (file instanceof File) {
      return URL.createObjectURL(file);
    } else if (typeof file === "string") {
      return file.startsWith("http") ? file : `${this.apiUrl}/${file}`;
    }
    return "";
  }

  lastTollFileName: string = "";
  // Remove a file from preview
  removeFile(index: number) {
    const file = this.previewTollFiles[index];

    if (file instanceof File) {
      // Remove newly uploaded file
      this.newTollFiles = this.newTollFiles.filter((f) => f !== file);
    } else {
      // Remove existing saved attachment
      this.existingTollFiles = this.existingTollFiles.filter((f) => f !== file);
    }

    // Update preview
    this.updatePreviewFiles();

    // Update lastTollFileName safely
    const allFiles = [...this.existingTollFiles, ...this.newTollFiles];
    const lastFile = allFiles[allFiles.length - 1];

    if (!lastFile) {
      this.lastTollFileName = "";
    } else if (lastFile instanceof File) {
      this.lastTollFileName = lastFile.name;
    } else if (typeof lastFile === "string") {
      this.lastTollFileName = lastFile.split("/").pop() || lastFile;
    }
  }

  backTo() {
    window.history.back();
  }
  cancel() {
    this.isFileSelcted = false;
    this.isShown = true;
    this.notShown = false;
    this.isFileNameShown = true;
  }

  fileChangeEventloadingSlipBackAttchment(fileInput: any) {
    this.loadingSlipsBack = [];
    for (var i = 0; i < fileInput.target.files.length; i++) {
      this.loadingSlipsBack.push(fileInput.target.files[i]);
    }
  }

  onKeyloadingSlipBackAttchment(event: any) {
    if (this.editLR.get("loadingSlipAttchmentBack").invalid) {
      this.addvalidatorcss("loadingSlipAttchmentBackctrl");
    } else {
      this.removevalidatorcss("loadingSlipAttchmentBackctrl");
    }
  }

  addloadingSlipsBack() {
    const formData = new FormData();
    for (let i = 0; i < this.loadingSlipsBack.length; i++) {
      formData.append("loadingSlipsback[]", this.loadingSlipsBack[i]);
    }
    debugger;
    this.superAdminService
      .addloadingSlipsBack(formData)
      .subscribe(
        (res: {
          rawdata: any;
          status: any;
          message: any;
          authorization: any;
          code: any;
        }) => {
          if (res.status == true) {
            this.toastr.success(res.message);
            this.loadingSlipsBackString = res.rawdata;
          } else {
            if (res.status == 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.error(res.message);
            }
          }
        }
      );
  }
  previewLRBack() {
    // console.log("POD back",this.particlarLR.loadingSlipAttchmentBack[0])

    this.podBack = this.particlarLR.loadingSlipAttchmentBack;
    let fileback: any = this.podBack[0];

    if (fileback) {
      const dialogRef = this.dialog.open(ImagePreviewComponent, {
        width: "80%",
        height: "90vh",
        data: { backFile: fileback },
      });
    } else {
      this.toastr.error("Please upload attachment");
    }
  }

  onManualLRFocus() {
    const ctrl = this.editLR.get("manualLR_no");

    if (ctrl?.hasError("duplicate")) {
      ctrl.setErrors(null);
    }

    this.removevalidatorcss("manualLR_noctrl");
  }
  onManualLRBlur() {
    const ctrl = this.editLR.get("manualLR_no");
    const manualLRNo = ctrl?.value?.trim();

    if (!manualLRNo) return;

    // Exclude current LR id
    this.superAdminService
      .checkManualLR(manualLRNo, this.particlarLR?._id)
      .subscribe({
        next: (res) => {
          if (res.exists) {
            ctrl?.setErrors({ duplicate: true });
            this.addvalidatorcss("manualLR_noctrl");
            this.toastr.error(res.message || "Manual LR number already exists");
          } else {
            if (ctrl?.hasError("duplicate")) {
              ctrl.setErrors(null);
            }
            this.removevalidatorcss("manualLR_noctrl");
          }
        },
        error: () => {
          // optional toast
        },
      });
  }

  onKeyDate(event: any) {
  // ✅ Same behavior as Edit Tracker
  if (!this.isRoleSuperVisor) {
    this.removevalidatorcss("datectrl");
    return;
  }

  const ctrl = this.editLR.get("date");
  if (!ctrl?.value) return;

  const inputDate = new Date(ctrl.value);
  inputDate.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  // ❌ Invalid date for supervisor
  if (inputDate < yesterday || inputDate > today) {
    ctrl.setValue("");
    this.addvalidatorcss("datectrl");
    return;
  }

  // ✅ Valid date
  this.removevalidatorcss("datectrl");
}


}
